var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.668 13.166H17.3346V14.8327H0.667969V13.166H2.33464V7.33268C2.33464 5.56457 3.03701 3.86888 4.28726 2.61864C5.5375 1.36839 7.23319 0.666016 9.0013 0.666016C10.7694 0.666016 12.4651 1.36839 13.7153 2.61864C14.9656 3.86888 15.668 5.56457 15.668 7.33268V13.166ZM14.0013 13.166V7.33268C14.0013 6.0066 13.4745 4.73483 12.5368 3.79715C11.5992 2.85947 10.3274 2.33268 9.0013 2.33268C7.67522 2.33268 6.40345 2.85947 5.46577 3.79715C4.52809 4.73483 4.0013 6.0066 4.0013 7.33268V13.166H14.0013ZM6.5013 16.4993H11.5013V18.166H6.5013V16.4993Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7dc40459e27e8945060d5f9fcb9db775.svg";
export { ForwardRef as ReactComponent };